module.exports = __webpack_public_path__ + "img/1.79d91d8d.jpg";